import { createRouter, createWebHistory } from 'vue-router';
import { isIntradayFeatureEnabled } from '../utils/featureFlags';

const intradayRoute = isIntradayFeatureEnabled()
  ? {
    path: '/intraday',
    name: 'intraday-forecast',
    component: () => import('../views/IntradayForecastView.vue'),
  }
  : { path: '/intraday', redirect: { name: 'dashboard' } };

const routes = [
  { path: '/', name: 'dashboard', component: () => import('../views/DashboardView.vue') },
  { path: '/crypto', name: 'crypto-forecast', component: () => import('../views/BtcForecastView.vue') },
  { path: '/crypto/charts', name: 'crypto-charts', component: () => import('../views/BtcChartsView.vue') },
  { path: '/crypto/backtest', name: 'crypto-backtest', component: () => import('../views/BtcBacktestView.vue') },
  { path: '/btc', redirect: { name: 'crypto-forecast' } },
  { path: '/btc/charts', redirect: { name: 'crypto-charts' } },
  { path: '/btc/backtest', redirect: { name: 'crypto-backtest' } },
  { path: '/simulator', name: 'simulator', component: () => import('../views/SimulatorView.vue') },
  {
    path: '/advisor',
    name: 'trading-advisor',
    component: () => import('../views/TradingAdvisorView.vue'),
    meta: { title: 'Trading Advisor' },
  },
  { path: '/trading-news', redirect: { name: 'trading-advisor' } },
  { path: '/daily', name: 'daily-forecast', component: () => import('../views/DailyForecastView.vue') },
  { path: '/daily/results', name: 'daily-results', component: () => import('../views/DailyResultsView.vue') },
  intradayRoute,
  { path: '/history', name: 'history', component: () => import('../views/HistoryView.vue') },
  { path: '/settings', name: 'settings', component: () => import('../views/SettingsView.vue') },

  // Site-wide legal pages (footer links; separate from /wellbeing/*)
  {
    path: '/financial-disclaimer',
    name: 'financial-disclaimer',
    component: () => import('../views/legal/FinancialDisclaimerView.vue'),
    meta: { title: 'Financial Disclaimer' },
  },
  {
    path: '/copyright',
    name: 'copyright-disclaimer',
    component: () => import('../views/legal/CopyrightDisclaimerView.vue'),
    meta: { title: 'Copyright Disclaimer' },
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/legal/PrivacyDisclosureView.vue'),
    meta: { title: 'Privacy Policy' },
  },
  {
    path: '/terms-of-service',
    name: 'terms-of-service',
    component: () => import('../views/legal/TermsOfServiceView.vue'),
    meta: { title: 'Terms of Service' },
  },
  {
    path: '/cookies',
    name: 'cookies',
    component: () => import('../views/legal/CookiesPolicyView.vue'),
    meta: { title: 'Cookie Policy' },
  },

  // Wellbeing (mental health app integration)
  {
    path: '/wellbeing',
    name: 'wellbeing',
    component: () => import('../views/wellbeing/Coaching.vue'),
    meta: { title: 'Coaching' },
  },
  {
    path: '/wellbeing/coaching',
    name: 'wellbeing-coaching',
    component: () => import('../views/wellbeing/Coaching.vue'),
    meta: { title: 'Coaching' },
  },
  {
    path: '/wellbeing/chat',
    name: 'wellbeing-chat',
    component: () => import('../views/wellbeing/MentalHealthChat.vue'),
    meta: { title: 'Wellbeing chat' },
  },
  {
    path: '/wellbeing/playlist',
    name: 'wellbeing-playlist',
    component: () => import('../views/wellbeing/WellnessPlaylist.vue'),
    meta: { title: 'Calming playlist' },
  },
  {
    path: '/wellbeing/privacy',
    name: 'wellbeing-privacy',
    component: () => import('../views/wellbeing/PrivacyPolicy.vue'),
    meta: { title: 'Privacy Policy' },
  },
  {
    path: '/wellbeing/terms-of-service',
    name: 'wellbeing-terms',
    component: () => import('../views/wellbeing/TermsOfService.vue'),
    meta: { title: 'Terms of Service' },
  },
  {
    path: '/wellbeing/cookies',
    name: 'wellbeing-cookies',
    component: () => import('../views/wellbeing/CookiesPolicy.vue'),
    meta: { title: 'Cookies Policy' },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach((to) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
});

export default router;
